import { useLanguage } from '.';
import createPersistedState from 'use-persisted-state';
const useLanguagePreference = createPersistedState('language-preference');
export const LanguageTranslator = props => {
  const [language] = useLanguagePreference('en');
  const { getLanguageText } = useLanguage(language);
  return props.children({ getLanguageText });
};
